module.exports = "#define GLSLIFY 1\nuniform vec3 viewVector;\nuniform float c;\nuniform float p;\nuniform float uTime;\nvarying float intensity;\nvarying  vec2 vUv;\n\nvoid main(){\n\n    vUv = uv;\n\n    vec3 vNormal = normalize( normalMatrix * normal );\n\tvec3 vNormel = normalize( normalMatrix * viewVector );\n    intensity = pow(c - abs(dot(vNormal, vec3(0, 0, 1))), p);\n\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n }"


//////////////////
// WEBPACK FOOTER
// ./src/js/shaders/xRay.vert
// module id = cRIw
// module chunks = 1